/**
 * Semantic Scholar's relevance search returns total=0 for natural phrasing
 * that a person would type — "cosmology of NGC 6164/6165" finds nothing while
 * "cosmology NGC 6164 6165" finds hundreds of on-object papers (beta report,
 * 2026-09-21). This mirrors the backend's `simplify_query` so the Curate
 * search box can retry once with the same stripping.
 */

const STOPWORDS = new Set([
  "a", "an", "the", "of", "in", "on", "for", "and", "or", "to", "with", "by",
  "at", "from", "into", "its", "their", "regarding", "about", "vs", "versus",
  "as", "is", "are", "be", "how", "what", "why", "does", "do",
]);

// Keep letters/digits/underscore, apostrophes, hyphens and whitespace.
const NON_QUERY_CHARS = /[^\p{L}\p{N}_'’\s-]+/gu;
// A dash standing alone between spaces (" - ") is a subtitle separator, not
// part of a designator like "NGC 6164-5".
const LONE_DASH = /(?:(?<=\s)|^)-+(?:(?=\s)|$)/g;

/**
 * Strip punctuation and stopwords. Returns the trimmed original when nothing
 * would survive, so a query never degrades to an empty string.
 */
export function simplifySearchQuery(text: string): string {
  const trimmed = text.trim();
  if (!trimmed) return "";
  const cleaned = trimmed.replace(NON_QUERY_CHARS, " ").replace(LONE_DASH, " ");
  const words = cleaned.split(/\s+/).filter((w) => w && !STOPWORDS.has(w.toLowerCase()));
  return words.length > 0 ? words.join(" ") : trimmed;
}
